import { handleAction } from '@/service/twilioService';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

/**
 * Start an App Integration session.
 * Calls backend to validate availability & create session/ticket.
 */
export const startAppIntegrationCall = async (corpId, projectId, userId, options = {}) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.APP_INTEGRATION_START_CALL,
        requestBody: JSON.stringify({
            sessionId: options.sessionId,
            startTime: options.startTime,
            customerDeviceId: options.customerDeviceId,
            agentDeviceId: options.agentDeviceId,
            language: options.language,
        }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

/**
 * End an App Integration session.
 * Idempotent: calling multiple times only ends once.
 * 
 * @param {string} reason - 'manual_stop' | 'silence_auto_end' | 'force_cleanup'
 */
export const endAppIntegrationCall = async (
    corpId,
    projectId,
    userId,
    {
        sessionId,
        ticketId,
        reason,
        endedAt,
        durationSec,
    }
) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId,
        actionType: TelephoneConstant.ACTION.APP_INTEGRATION_END_CALL,
        requestBody: JSON.stringify({
            sessionId,
            ticketId,
            reason,
            endedAt,
            durationSec,
        }),
    };

    return handleAction(requestDto);
};

/**
 * Keep an App Integration ticket alive while its browser stream is active.
 */
export const updateAppIntegrationHeartbeat = async (
    corpId,
    projectId,
    userId,
    { sessionId, ticketId }
) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId,
        actionType: TelephoneConstant.ACTION.APP_INTEGRATION_UPDATE_HEARTBEAT,
        requestBody: JSON.stringify({ sessionId, ticketId }),
    };

    return handleAction(requestDto);
};

/**
 * Update App Integration ticket data that becomes available after the session ends.
 */
export const updateAppIntegrationTicketData = async (
    corpId,
    projectId,
    userId,
    {
        sessionId,
        ticketId,
        recordingUrl,
        transcriptUrl,
        summary,
    }
) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId,
        actionType: TelephoneConstant.ACTION.APP_INTEGRATION_UPDATE_TICKET_DATA,
        requestBody: JSON.stringify({
            sessionId,
            ticketId,
            recordingUrl,
            transcriptUrl,
            summary,
        }),
    };

    return handleAction(requestDto);
};
